import CardDateConnected from './CardDateConnected'
export default CardDateConnected
